
export default [{
    name: 'dashboard',
    children: [
        {
            path:'/manage/traffic/updateorder',
            name:'trafficorder',
            component:resolve => require(['./traffic'], resolve)
        },
        {
            path:'/manage/:ServiceType?/updateorder',
            name:'updateorder',
            component:resolve => require(['./demandorder'], resolve)
        }
    ],
}]


// WEBPACK FOOTER //
// ./src/views/mall/newdemand/router.js